import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { FlyInTransition } from '../transitions/transitions';
import Modal from '../../containers/common/Modal';
import { ErrorText } from './common';
import { postCurrentBS } from '../../services';

import closeIcon from '../../images/health-content/close-modal.svg';
import ClockIcon from '../../images/health-content/clock-icon.svg';
import BloodSugarIcon from '../../images/health-content/blood-sugar-icon.svg';

const BloodSugarInputBox = styled.input`
  width: 60%;
  border-bottom: 1px solid black;
  font-size: 48px;
  font-weight: 700;
  color: #01040d;
  text-align: center;
  ::placeholder {
    text-align: center;
    font-size: 48px;
    font-weight: 500;
  }
`;

const BloodSugarLabel = styled.div`
  padding: 12px 16px;
  border-radius: 12px;
  background: ${(props) =>
    props.value === props.logTime ? 'var(--primary-button)' : '#F0F3F6'};
  color: ${(props) => (props.value === props.logTime ? '#FFFFFF' : '#767787')};
  cursor: pointer;
`;

const BloodSugarModal = ({ hideModal, measuredOn }) => {
  const [showModal, setShowModal] = useState(true);
  const [value, setValue] = useState('');
  const [logTime, setLogTime] = useState('Fasting');
  const [showErrorText, setShowErrorText] = useState(false);
  const { authToken } = useSelector((state) => state.user);
  const timer = useRef(null);

  const validateInput = () => {
    if (Number(value) < 50 || Number(value) > 400) return false;
    else return true;
  };

  useEffect(() => {
    if (!showModal)
      timer.current = setTimeout(() => {
        hideModal();
      }, 300);
    return () => {
      clearTimeout(timer);
      timer.current = null;
    };
  }, [showModal]);

  return (
    <Modal>
      <div
        className="modalContainer"
        onClick={(e) => {
          e.stopPropagation();
          setShowModal(false);
        }}
      >
        <FlyInTransition in={showModal} mountOnEnter unmountOnExit appear>
          <div className="modalBody" onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                paddingLeft: '0',
                paddingRight: '0',
                overflowY: 'auto',
                minHeight: '150px',
              }}
            >
              <div className="flex justify-between items-center border-b border-txtlight-shades4">
                <div className="flex items-center p-20px py-16px">
                  <img src={BloodSugarIcon} alt=""></img>
                  <p className="ml-12px text-body-m font-semibold">
                    Blood Sugar
                  </p>
                </div>
                <img
                  src={closeIcon}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(false);
                  }}
                  className="pr-20px"
                  alt=""
                />
              </div>
              <div className="flex py-40px justify-between items-center flex-col h-full">
                <p className="text-title-xl font-bold">
                  What are you measuring?
                </p>
                <div className="flex justify-around items-center mt-32px mb-48px">
                  <BloodSugarLabel
                    value="Fasting"
                    logTime={logTime}
                    onClick={(e) => {
                      e.stopPropagation();
                      setLogTime('Fasting');
                    }}
                  >
                    Fasting
                  </BloodSugarLabel>
                  <BloodSugarLabel
                    value="Random"
                    logTime={logTime}
                    onClick={(e) => {
                      e.stopPropagation();
                      setLogTime('Random');
                    }}
                    className="mx-12px"
                  >
                    Random
                  </BloodSugarLabel>
                  <BloodSugarLabel
                    value="Post-Meal"
                    logTime={logTime}
                    onClick={(e) => {
                      e.stopPropagation();
                      setLogTime('Post-Meal');
                    }}
                  >
                    Post-Meal
                  </BloodSugarLabel>
                </div>
                <div className="flex flex-col justify-evenly items-center">
                  <BloodSugarInputBox
                    type="number"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    placeholder="00"
                    onChange={(e) => setValue(e.target.value)}
                  />
                  <label className="mt-4px">mg/del</label>
                </div>
                {showErrorText && <ErrorText />}
                <div className="flex flex-col justify-center items-center">
                  <div className="flex flex-col mt-52px">
                    <div className="flex">
                      <img src={ClockIcon} alt=""></img>
                      <p className="text-body-s text-sub ml-8px">
                        Last logged On
                      </p>
                    </div>
                    <p className="text-body-l font-medium text-txtlight self-center">
                      {measuredOn ? measuredOn : 0}
                    </p>
                  </div>
                  <p className="text-body-s"></p>
                </div>
                {value.length > 0 && (
                  <div className="pb-20px px-20px mt-28px w-full">
                    <button
                      onClick={async (e) => {
                        try {
                          if (validateInput()) {
                            await postCurrentBS(authToken, {
                              value: value,
                              type: logTime,
                              measuredOn: new Date().toISOString().slice(0, 10),
                              startConversation: false,
                            });
                            setShowModal(false);
                            setShowErrorText(false);
                          } else {
                            e.stopPropagation();
                            setShowErrorText(true);
                          }
                        } catch (error) {
                          console.error('Error posting BS:', error);
                        }
                      }}
                      className="flex justify-center w-full bg-primary text-textbox mb-20px rounded-12 text-body-s font-semibold py-14px"
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </FlyInTransition>
      </div>
    </Modal>
  );
};

export default BloodSugarModal;
